import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Modal } from './ui';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
  loading?: boolean;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  type = 'danger',
  loading = false,
}) => {
  const { t } = useLanguage();
  if (!isOpen) return null;

  return (
    <Modal
      title={title}
      onClose={onClose}
      busy={loading}
      size="sm"
      footer={
        <>
          <button type="button" onClick={onClose} disabled={loading} className="btn btn-secondary">
            {cancelText || t('common.cancel')}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className={`btn ${type === 'danger' ? 'btn-danger' : 'btn-primary'}`}
          >
            {loading ? t('common.working') : confirmText || t('common.confirm')}
          </button>
        </>
      }
    >
      <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-300">{message}</p>
    </Modal>
  );
};

export default ConfirmDialog;
